<template lang="">
  <div class="cardContent">
    <el-tabs v-model="time" @tab-click="handleClick">
      <el-tab-pane label="今天" name="1"></el-tab-pane>
      <el-tab-pane label="最近三天" name="3"></el-tab-pane>
      <el-tab-pane label="最近一周" name="7"></el-tab-pane>
    </el-tabs>
    <div class="selectBtn">
      <div
        :class="selectOn == index ? 'selectBtnList selectOn' : 'selectBtnList'"
        v-for="(item, index) in select"
        :key="index"
        @click="selectClick(index)"
      >
        <img :src="item.img" alt="" />
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="chart">
      <loadEchart ref="echarts"></loadEchart>
    </div>
  </div>
</template>

<script>
// import { loadSqChart } from "../chart/sqChartData";
// import { getScreenV2FindWlwSoilGetLSSJ } from "@/api/zhwl";
import { findRealData, findHistoryData } from "@/api/zhwl";
import { sqOptions } from "@/util/sqOptions";
export default {
  data() {
    return {
      time: "1",
      selectOn: 0,
      select: [
        {
          name: "温度",
          img: "",
        },
        {
          name: "湿度",
          img: "",
        },
        // {
        //   name: "土壤电导率",
        // },
        // {
        //   name: "太阳总辐射",
        // },
        // {
        //   name: "土壤pH",
        // },
      ],
      endTime: this.$formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
      startTime: this.$formatDate(
        new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000),
        "yyyy-MM-dd hh:mm:ss"
      ),
      equimentIds: [],
      equimentTimes: [],
      sqDatas: [
        {
          name: "10cm温度",
          sname: "10",
          sname1: "温",
          value: "--",
          unit: "℃",
          indexs: [],
          echartsData: [],
        },
        {
          name: "10cm湿度",
          sname: "10",
          sname1: "湿",
          value: "--",
          channel: "6",
          unit: "%",
          type: "humi",
          indexs: [],
          echartsData: [],
        },
        {
          name: "20cm温度",
          sname: "20",
          sname1: "温",
          value: "--",
          channel: "5",
          unit: "℃",
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
        {
          name: "20cm湿度",
          sname: "20",
          sname1: "湿",
          value: "--",
          channel: "3",
          unit: "%",
          top: "5%",
          type: "temp",
          indexs: [],
          echartsData: [],
        },
        {
          name: "40cm温度",
          sname: "40",
          sname1: "温",
          value: "--",
          channel: "5",
          unit: "℃",
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
        {
          name: "40cm湿度",
          sname: "40",
          sname1: "湿",
          value: "--",
          channel: "3",
          unit: "%",
          top: "5%",
          type: "temp",
          indexs: [],
          echartsData: [],
        },
      ],
    };
  },
  mounted() {
    // this.sqchart = this.$echarts.init(this.$refs.sqLineChart);
    // this.loadData();
    // window.addEventListener("resize", () => {
    //   this.sqchart.resize();
    // });
    this.getData();
  },
  methods: {
    handleClick(val) {
      if (val.name === "3") {
        this.startTime = this.$formatDate(
          new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000),
          "yyyy-MM-dd hh:mm:ss"
        );
      } else if (val.name === "7") {
        this.startTime = this.$formatDate(
          new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
          "yyyy-MM-dd hh:mm:ss"
        );
      } else {
        this.startTime = this.$formatDate(
          new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000),
          "yyyy-MM-dd hh:mm:ss"
        );
      }
      this.getHistoryData();
    },
    selectClick(index) {
      if (this.selectOn == index) return;
      this.selectOn = index;
      // this.loadData();
      this.$refs.echarts.setOptions(this.getOptions());
    },

    getData() {
      this.$refs.echarts.showLoading();
      this.equimentIds = [];
      this.equimentTimes = [];
      // getWlwCode().then((res) => {
      let res = {
        data: window.deviceData,
      };
      if (res && res.data && res.data.soil) this.deviceCode = res.data.soil;
      else this.deviceCode = "CJ02A-2110027";
      findRealData(this.deviceCode)
        .then((res) => {
          if (
            res.code == 200 &&
            res.data &&
            res.data.sensor &&
            res.data.sensor.length > 0
          ) {
            const sensor = res.data.sensor;

            this.sqDatas.map((item) => {
              sensor.some((ele) => {
                if (
                  ele.name.indexOf(item.sname) > -1 &&
                  ele.name.indexOf(item.sname1) > -1
                ) {
                  item.name = ele.name;
                  item.unit = ele.sensor_type_unit || ele.unit || "";
                  item.value = ele.value || "";
                  item.echartsData = [];
                  item.indexs = [];
                  this.equimentIds.push(ele.id);

                  return true;
                }
              });

              return item;
            });
            console.log(
              "气象站",
              this.equimentIds,
              this.sqDatas,
              this.equimentIds.length > 0
            );
            debugger;
            if (this.equimentIds.length > 0) this.getHistoryData();
          } else this.$refs.echarts.noOption();
        })
        .catch(() => {
          this.$refs.echarts.noOption();
        });
      // });
    },
    getHistoryData(
      ids = "equimentIds",
      type = "sqDatas",
      timeType = "equimentTimes"
    ) {
      this.$refs.echarts.showLoading();
      console.log("getHistoryData");
      let start_time = this.startTime;

      const end_time = this.$formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
      let group_type = this.timeIndex == 0 ? 5 : 4;
      const data = {
        sensor_ids: this[ids].join(","),
        group_type,
        start_time,
        end_time,
      };
      console.log("end_time", this.timeIndex, data);
      findHistoryData(data)
        .then((res) => {
          if (
            res.code == 200 &&
            res.data &&
            res.data.sensor &&
            res.data.sensor.length > 0 &&
            res.data.time &&
            res.data.time.length > 0
          ) {
            const datas = res.data;
            this[timeType] = datas.timestamp.map((it) => {
              return this.$formatDate(new Date(it), "MM-dd hh时");
            });
            this[type].map((item) => {
              datas.sensor.some((it) => {
                if (
                  it.hd_device_sensor_name.indexOf(item.sname) > -1 &&
                  it.hd_device_sensor_name.indexOf(item.sname1) > -1
                ) {
                  item.echartsData = it.data ? it.data : it.avg_data;
                  item.echartsData = item.echartsData.map((ele) => {
                    return ele || 0;
                  });
                  item.indexs = it.index;
                  return true;
                }
              });
              return item;
            });

            this.$refs.echarts.setOptions(this.getOptions());
          }
        })
        .catch(() => {
          this.$refs.echarts.noOption();
        });
    },
    getOptions() {
      let datas = [];
      let type = this.selectOn == 0 ? "温" : "湿",
        unit = this.selectOn == 0 ? "℃" : "%";
      this.sqDatas.map((item) => {
        if (item.name.indexOf(type) > -1) {
          datas.push(item);
        }
      });
      console.log("getOptions", datas);
      return sqOptions(datas, this.equimentTimes, unit);
    },
    // loadData() {
    //   getScreenV2FindWlwSoilGetLSSJ({
    //     // deviceNo: this.graphic.code,
    //     wlwSoilId: "60b29c6b3a0f482fbba7c4485327ec2f",
    //     startTime: this.startTime,
    //     endTime: this.endTime,
    //     orderTime: "asc",
    //   }).then((res) => {
    //     let istoday = false;
    //     if (res.code === 200) {
    //       let data = [];
    //       let unit = "";
    //       let type = "";
    //       // console.log(res.data,'-----土壤墒情');
    //       if (this.selectOn === 0) {
    //         istoday = true;
    //         type = "3";
    //         for (var i = 0; i < res.data.length; i++) {
    //           data.push({
    //             date: res.data[i].date,
    //             value10: res.data[i].temp10,
    //             value20: res.data[i].temp20,
    //             value30: res.data[i].temp30,
    //           });
    //         }
    //         unit = "℃";
    //       } else if (this.selectOn === 1) {
    //         type = "3";
    //         for (i = 0; i < res.data.length; i++) {
    //           data.push({
    //             date: res.data[i].date,
    //             value10: res.data[i].humi10,
    //             value20: res.data[i].humi20,
    //             value30: res.data[i].humi30,
    //           });
    //         }
    //         unit = "%";
    //       } else if (this.selectOn === 2) {
    //         for (i = 0; i < res.data.length; i++) {
    //           data.push({
    //             date: res.data[i].date,
    //             value10: res.data[i].electric,
    //           });
    //         }
    //         unit = "µS/cm";
    //       } else if (this.selectOn === 3) {
    //         for (i = 0; i < res.data.length; i++) {
    //           data.push({
    //             date: res.data[i].date,
    //             value10: res.data[i].radiation,
    //           });
    //         }
    //         unit = "W/m2";
    //       } else if (this.selectOn === 4) {
    //         for (i = 0; i < res.data.length; i++) {
    //           data.push({
    //             date: res.data[i].date,
    //             value10: res.data[i].ph,
    //           });
    //         }
    //         unit = "";
    //       }
    //       // let dtype = "yyyy-MM-dd";
    //       // if (this.time == "1") {
    //       //   dtype = "hh:mm";
    //       // }
    //       loadSqChart(this.sqchart, data, unit, type, istoday);
    //     }
    //   });
    // },
  },
};
</script>

<style lang="stylus" scoped>
.cardContent
  position relative
  height 100%
  padding 0px 12px
  box-sizing border-box
  .chart
    position relative
    height calc(100% - 30px)
/deep/.el-tabs__header
  margin 0
/deep/ .el-tabs
  padding-left 10px
  marign-bottom 4px
  margin-top -4px
  box-sizing border-border-box
/deep/.el-tabs__item
  height 30px
  line-height 30px
  color #fff
  font-size 13px

/deep/.el-tabs__item.is-active
  color rgb(243, 208, 19)

/deep/.el-tabs__nav-wrap::after
  height 0

/deep/.el-tabs__active-bar
  background rgb(243, 208, 19)

.selectBtn
  position absolute
  top 0px
  right 26px
  display flex
  flex-wrap wrap
  justify-content center
  z-index 1

.selectBtnList
  padding 3px
  cursor pointer

.selectBtnList span
  color #fff

.selectOn span
  color rgb(14, 156, 255) !important
</style>
